








import {defineComponent} from "@vue/composition-api";

export default defineComponent({
  name: "LayoutDefaultBlock",
  props: {
    tag: {type: String, default: "div"},
    padding: {type: Boolean, default: true},
    extraClass: {type: String}
  }
})
